export enum EMicStatus {
  enabled = "enabled",
  disabled = "disabled",
  recording = "recording",
}

export type TMicStatus = keyof typeof EMicStatus;